import insertInstrumentationInList from '../helpers/insertInstrumentationInList';
import { SearchRequestInstrumentation } from 'owa-search-service';
import searchDiagnosticsStore from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'addSearchRequestInstrumentationMutator',
    function addSearchRequestInstrumentationMutator(
        searchRequestInstrumentation: SearchRequestInstrumentation
    ) {
        insertInstrumentationInList(
            searchRequestInstrumentation,
            searchDiagnosticsStore.searchInstrumentationList
        );
    }
);
